import * as PIXI from 'pixi.js';
import { WordElementSprite } from './WordElementSprite';

/**
 * Contains a continguous span of highlighted text elements.
 */
export class HighlightSpan extends PIXI.Container {
    classType = 'HighlightSpan';

    _isPlaceholder: Boolean;

    constructor(isPlaceholder: Boolean = false) {
        super();
        this._isPlaceholder = isPlaceholder;
    }

    get wordElementSprites(): WordElementSprite[] {
        return this.children.filter(child => child instanceof WordElementSprite) as WordElementSprite[];
    }

    /**
     * If the span is a placeholder, it is used only for its dimension and is not animated or used in any way to create
     * graphics. It's main purpose is that HighlightLine.getBounds() returns the bounds of a line, and not just the
     * visible highlighted spans within it.
     */
    get isPlaceholder() {
        return this._isPlaceholder;
    }
}
